// 首页
export default {
    displayInfo: 'Показать информацию',
    user: 'Пользователь',
    pleaseEnterId: 'Пожалуйста, введите серийный номер устройства',
}